module.exports = __webpack_public_path__ + "static/kathyayan-f88523ce5a0cd58e4d81d3627bfdc7f1.png";